import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyA8D2w0J8auihu3BbR8McIpoSduDfI2jxo",
  authDomain: "are-you-genius-1f253.firebaseapp.com",
  projectId: "are-you-genius-1f253",
  storageBucket: "are-you-genius-1f253.firebasestorage.app",
  messagingSenderId: "771421054895",
  appId: "1:771421054895:web:7a27a9c69f722069ebb15a",
  measurementId: "G-RE3R9WGMH9"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const googleProvider = new GoogleAuthProvider();

export default app;
